import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyBmfa0NXg38Z6AuFI0etoOPzDk18II3HFo",
  authDomain: "bebe-note.firebaseapp.com",
  projectId: "bebe-note",
  storageBucket: "bebe-note.firebasestorage.app",
  messagingSenderId: "314067676587",
  appId: "1:314067676587:web:8b8dd36dcbb46ff23976ee",
  measurementId: "G-EEKEZPY4TX"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// Analytics 지원 여부 확인 후 초기화
let analytics = null;
isSupported().then(supported => {
  if (supported) {
    analytics = getAnalytics(app);
    console.log('✅ Firebase Analytics initialized successfully');
    console.log('📊 Analytics Measurement ID:', 'G-EEKEZPY4TX');
    console.log('🔍 Check Firebase Console in 5-10 minutes for real-time data');

    // 테스트 이벤트 전송
    import('firebase/analytics').then(({ logEvent }) => {
      logEvent(analytics, 'analytics_test', { timestamp: new Date().toISOString() });
      console.log('✅ Test event sent to Analytics');
    });
  } else {
    console.warn('⚠️ Firebase Analytics is not supported in this environment');
  }
}).catch(err => {
  console.error('❌ Firebase Analytics initialization failed:', err);
});

export { analytics };